export const SAVE_KEYS = {
    BLOCKJAM_PROGRESS: 'blockjam_progress',
};
